export default "__VITE_ASSET__DajIJg5q__"